import React from "react";
import Navigation from "../components/marketing/Navigation";
import HeroSection from "../components/marketing/HeroSection";
import FeatureSlider from "../components/marketing/FeatureSlider";
import ValueCards from "../components/marketing/ValueCards";
import ContactSection from "../components/marketing/ContactSection";
import PageMeta from "../components/common/PageMeta";
import { Package } from "lucide-react";
import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-amber-500 selection:text-white">
      <PageMeta
        title="Export Stuff - Global Trade & Ceramic Inventory Automation"
        description="Streamline international export documentation, quotation tracking, packing lists, and ceramic tile inventory management with the Export Stuff enterprise platform."
      />

      <Navigation />
      <HeroSection />
      <ValueCards />
      <FeatureSlider />
      <ContactSection />

      {/* Enterprise Footer */}
      <footer className="bg-white border-t border-slate-200 text-slate-600 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="space-y-2 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2.5">
                <div className="p-2 rounded-xl bg-amber-100 text-amber-800 border border-amber-200">
                  <Package className="h-5 w-5" />
                </div>
                <span className="text-lg font-extrabold text-slate-900 tracking-tight">
                  Export <span className="text-amber-600">Stuff</span>
                </span>
              </div>
              <p className="text-xs text-slate-500 max-w-sm">
                Simplifying global trade documentation, Incoterm pricing, and export tile inventory management worldwide.
              </p>
            </div>

            <div className="flex items-center gap-6 text-xs font-bold text-slate-700">
              <Link to="/login" className="hover:text-amber-700 transition-colors">Sign In</Link>
              <Link to="/signup" className="hover:text-amber-700 transition-colors">Register Workspace</Link>
              <a href="#features" className="hover:text-amber-700 transition-colors">Features</a>
              <a href="#contact" className="hover:text-amber-700 transition-colors">Support</a>
            </div>

            <div className="text-center md:text-right space-y-1">
              <p className="text-xs text-slate-500">
                © 2026 Export Stuff Inc. All rights reserved.
              </p>
              <p className="text-[11px] text-amber-700 font-bold">
                Trusted by 100+ ceramics manufacturers and global trade exporters
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
